import Immutable from 'immutable';

const Video = Immutable.Record({
  id: 0,
  type: 'video',
  duration: 0,
  name: '',
  playUrl: '',
  previewImage: '',
  thumbnail: '',
  clipLinkId: 0,
  liveLinkId: 0,
  isVertical: false,
  vid:''
});

export default Video;



// WEBPACK FOOTER //
// ./src/models/video.js